import { Input } from "antd"
import { useEffect, useState } from "react"


const TimePickerCustom = ({ defaultValue, onChange, ...props }) => {
    const [open, setOpen] = useState(false)
    const [time, setTime] = useState({ h: '', m: '', meridian: '' })

    const formatVal = (val) => {
        var newVal = `${(time.h != '') ? time.h : '__'}:${(time.m != '') ? ((time.m < 10) ? "0" : "") + time.m : '__'} ${(time.meridian != '') ? time.meridian : '__'}`
        return newVal
    }

    const onBlur = (e) => {
        if (e?.relatedTarget?.className != "rc-time-picker-panel-select-option-selected") {
            setOpen(false)
        }
    }


    var h = [...Array(12).keys()].map((val, i) => {
        val++
        if (val != time.h) {
            return <li onMouseDown={(e) => { setTime({ ...time, h: e.target.value }) }} tabIndex={-1} role="button" value={val} className="">{(val < 10) ? "0" : ""}{val}</li>
        } else {
            return <li onBlur={onBlur} role="button" tabIndex={-1} className="rc-time-picker-panel-select-option-selected">{`${(time.h < 10) ? "0" : ""}${time.h}`}</li>
        }
    })

    var m = [...Array(60).keys()].map((val, i) => {
        if (val != time.m || typeof (time.m) != "number") {
            return <li onMouseDown={(e) => { setTime({ ...time, m: e.target.value }) }} tabIndex={-1} role="button" value={val} className="">{(val < 10) ? "0" : ""}{val}</li>
        } else {
            return <li onBlur={onBlur} role="button" tabIndex={-1} className="rc-time-picker-panel-select-option-selected">{`${(time.m < 10) ? "0" : ""}${time.m}`}</li>
        }
    })

    var meridian = ["AM", "PM"].map((val, i) => {
        if (val != time.meridian) {
            return <li onMouseDown={(e) => { setTime({ ...time, meridian: e.target.innerText }) }} tabIndex={-1} role="button" className="" value={val}>{val}</li>
        } else {
            return <li onBlur={onBlur} role="button" tabIndex={-1} className="rc-time-picker-panel-select-option-selected">{time.meridian}</li>
        }
    })
    var inp = <a></a>

    useEffect(() => {
        if (time.h && time.m && time.meridian) {
            onChange(formatVal())
            setOpen(false)
        }
    }, [time])
    return (
        <div>
            <Input
                onFocus={() => { setOpen(true) }}
                onBlur={onBlur}
                allowClear
                onChange={(e)=>{
                    if(e.target.value == ""){
                        setTime({ h: '', m: '', meridian: '' })
                        onChange("")
                    }
                }}
                {...props}
                value={(time.h || time.m || time.meridian) ? formatVal() : ''}
            />

            {open &&
                <div className="rc-time-picker-panel rc-time-picker-panel-column-3 rc-time-picker-panel-placement-bottomLeft">
                    <div className="rc-time-picker-panel-inner">
                        <div className="rc-time-picker-panel-combobox">
                            <div className="rc-time-picker-panel-select">
                                <ul>
                                    {h}
                                </ul>
                            </div>
                            <div className="rc-time-picker-panel-select">
                                <ul>
                                    {m}
                                </ul>
                            </div>
                            <div className="rc-time-picker-panel-select">
                                <ul>
                                    {meridian}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default TimePickerCustom